
import React, { useEffect, useState } from "react";
import axios from "axios";
import Tables from "./Tables";

const BASE_URL = process.env.REACT_APP_API_URL;
const ENDPOINT = "/dq-hollistic/rule-details";

const DEFAULT_PAGE = 1;
const DEFAULT_PAGE_SIZE = 10;

const RuleDetails = ({ filters, onFilterOptionsChange }) => {
  const { parentDomain, domain, subDomain, product } = filters;

  const [rows, setRows] = useState([]);
  const [ruleCount, setRuleCount] = useState(0)
  const [pagination, setPagination] = useState({
    page: DEFAULT_PAGE,
    pageSize: DEFAULT_PAGE_SIZE,
    totalPages: 0,
    totalCount: 0,
  });
  const [page, setPage] = useState(DEFAULT_PAGE);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
    const [activeSearchParams, setActiveSearchParams] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [sortBy, setsortBy] = useState(null);
  const [sortTableBy, setsortTableBy] = useState(null)
  const [columnSearch, setColumnSearch] = useState({
    rule_name: "",
    rule_description: "",
    dimension_name: "",
    check_name: "",
    data_asset_name: "",
    data_product_name: "",
    total_row_count: "",
    error_record_count: "",
    quality_score: "",
    execution_date: "",
  });


  const fetchData = async (params = {}) => {
    setLoading(true);
    setError(null);

    try {
    const res = await axios.get(`${BASE_URL}${ENDPOINT}`, {
        params: {
          parentDomain: parentDomain === "All Parent Domains" ? "" : parentDomain,
          domain: domain === "All Domains" ? "" : domain,
          subDomain: subDomain === "All Sub Domains" ? "" : subDomain,
          product: product === "All Products" ? "" : product,
          page,
          pageSize,
          sortBy: sortBy,
          sortOrder: sortTableBy,
          ...activeSearchParams,
        },
      });

      setRows(res.data.data || []);
      setRuleCount(res.data.ruleCount || 0);
      setPagination(res.data.pagination || pagination);

      if (res.data.filters && res.data.filters.parent_domains) {
        if (typeof onFilterOptionsChange === "function") {
          onFilterOptionsChange(res.data.filters.parent_domains);
        }
      }
    } catch (err) {
      setError("Failed to fetch rule details");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [parentDomain, domain, subDomain, product, page, pageSize, sortBy, sortTableBy,activeSearchParams]);

const handleColumnSearch = (key, value) => {
  setColumnSearch({ ...columnSearch, [key]: value });
};
const handleSearchSubmit = (key, value) => {
  const newSearchParams = { [key]: value };
  setActiveSearchParams(newSearchParams);
  setPage(1);
};
const handleReset = () => {
  setColumnSearch({
    rule_name: "",
    rule_description: "",
    dimension_name: "",
    check_name: "",
    data_asset_name: "",
    data_product_name: "",
    total_row_count: "",
    error_record_count: "",
    quality_score: "",
    execution_date: "",
  });
  setActiveSearchParams({});
  setPage(1);
};

  return (
    <div>
      <div className="pl-4 pr-4">
        <Tables
          tableData={rows}
          loading={loading}
          error={error}
          pagination={pagination}
          ruleCount={ruleCount}
          onColumnSearchChange={handleColumnSearch}
          columnSearch={columnSearch}
        onSearchSubmit={handleSearchSubmit}
          onReset={handleReset}
          onPageChange={(p) => setPage(p)}
          onPageSizeChange={(s) => {
            setPageSize(s);
            setPage(1);
          }}
          onSortChange={(column, order) => {
            setsortBy(column);
            setsortTableBy(order)
            console.log("sort by asc", order)
            console.log("sort by asc", column)

          }}

        />
      </div>
    </div>
  );
};

export default RuleDetails;
